import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function LegalMentions() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight mb-6">Mentions legales</h1>
          <p className="text-muted-foreground mb-10 leading-relaxed">
            Cette page presente les informations legales de l'editeur du site fasttask.agency.
          </p>

          <section className="space-y-8 text-sm md:text-base leading-relaxed text-muted-foreground">
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Editeur du site</h2>
              <p>Raison sociale: FastTask</p>
              <p>Email: contact@fasttask.agency</p>
              <p>Adresse: La Marsa, Tunisie</p>
              <p>Telephone: +216 29 275 042 / +216 24 112 051</p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Directeur de publication</h2>
              <p>FastTask</p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Hebergement</h2>
              <p>Le site est heberge par un prestataire professionnel conforme aux exigences de securite et de disponibilite.</p>
            </div>

            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Propriete intellectuelle</h2>
              <p>
                L'ensemble des contenus du site (textes, elements graphiques, logos, medias) est protege.
                Toute reproduction, distribution ou exploitation sans autorisation prealable est interdite.
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
